export const BASE_URL =
  "https://public-api.wordpress.com/rest/v1.1/sites/foodandquote.wordpress.com/";

export const createMarkup = (html) => ({
  __html: html,
});



// WEBPACK FOOTER //
// ./src/utils.js